import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function RiskReversal() {
  return <section id="guarantee" className="py-14 md:py-24 bg-charcoal relative overflow-hidden" data-id="element-306" data-mp="19b13rijlwbbt">
      <div className="max-w-3xl mx-auto px-6 text-center relative z-10" data-id="element-307" data-mp="1e81ck17ubs6m">
        <FadeIn data-id="element-308" data-mp="1j146wbkfz5nv">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-charcoal-dark border border-amber/30 mb-8" data-id="element-309" data-mp="1j1ndwx8k09n4">
            <ShieldCheckIcon className="w-8 h-8 text-amber" data-id="element-310" data-mp="1s0r04a30p55u" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-8" data-id="element-311" data-mp="1s2tzhkq28an8">
            La garantía
          </h2>
        </FadeIn>

        <FadeIn delay={0.15} className="space-y-6 text-lg text-offwhite-dim" data-id="element-312" data-mp="21zggfyf9mhjz">
          <p data-id="element-313" data-mp="2lszapp15o48">ELEVATE no te pide perfección. Te pide que seas honesto.</p>
          <p className="text-xl md:text-2xl font-heading font-bold text-sand leading-snug" data-id="element-314" data-mp="2nxaztt67rf2">
            Si en las primeras 2 semanas hacés los ejercicios y no lográs
            identificar por escrito tu patrón específico — el que se repite en
            tu vida, con nombre y apellido — te devuelvo el 100% de tu dinero.
          </p>
          <div className="mt-8 pt-8 border-t border-charcoal-light" data-id="element-315" data-mp="39g2u7yodwfim">
            <p className="italic" data-id="element-316" data-mp="39e87cetjydbw">Sin preguntas, sin letra chica.</p>
            <p className="mt-4 text-amber font-medium uppercase tracking-widest text-sm" data-id="element-317" data-mp="35gk9b2wkc4fs">
              Sin vueltas.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}